export default __webpack_public_path__ + "static/media/DrLarryShi.96f47bb6.png";